exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-button {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  font-size: 30px; }\n  .link-button .material-icons {\n    font-size: inherit; }\n\n.link-button:hover {\n  -webkit-transform: scale(1.2);\n          transform: scale(1.2); }\n\n.top-bar {\n  height: 60px;\n  width: 100%;\n  top: 0;\n  left: 0;\n  position: fixed;\n  z-index: 100;\n  background-color: #ffffff;\n  color: #2C3E50;\n  border-bottom: 1px solid rgba(52, 73, 94, 0.188235);\n  box-shadow: 0 0 14px -7px black; }\n  .top-bar .content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin: 0 35px; }\n\n.mat-menu-divider {\n  width: 80%;\n  border: 0;\n  border-bottom: 1px solid #b8b8b8;\n  margin: 0px auto; }\n\n.ml-auto {\n  margin-left: auto; }\n\n.mr-auto {\n  margin-right: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-top-bar/app-top-bar.component.scss
// module id = ../../../../../src/app/components/app-top-bar/app-top-bar.component.scss
// module chunks = main